export const JsonUtil = {

    // TODO MAINTENANCE replace deprecated function with convertJsonToObject
    /**
     * DEPRECATED, use convertJsonToObject
     * Caution, the methode can also deliver valid js objecte not only arrays. The function name is missleading.
     */
    convertJsonStringToArray(value) {

        if (!value) {           // check for null, undefined and "" (empty string)
            return [];
        }

        if (typeof value === "string") {
            try {
                return JSON.parse(value);
            } catch (error) {
                console.error('JSON parse failed:', value, error);
            }
        }

        return [];
    },

    /**
     * Converts a JSON string into a JavaScript object.
     * If the conversion fails or the value is empty, the given defaultValue will be returned.
     */
    convertJsonToObject(value, defaultValue = []) {
        if (!value) {
            return defaultValue;
        }

        if (typeof value === "string") {
            try {
                return JSON.parse(value);
            } catch (error) {
                console.error('JSON parse failed:', value, error);
                return defaultValue;
            }
        }

        // return original object (if avaliable or default)
        return (typeof value === "object") ? value : defaultValue;
    },


    convertArrayToJsonStringOrNull(value) {
        if (Array.isArray(value)) {
            try {
                return JSON.stringify(value);
            } catch (error) {
                console.error('JSON stringify failed:', value, error);
            }
        } else {
            console.error('Value is not an array:', value);
        }
        return null;
    },

};
